export function getInitials(name) {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function formatFollowers(count) {
  if (count == null || Number.isNaN(Number(count))) return "—";
  const n = Number(count);
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1).replace(/\.0$/, "")}K`;
  return String(n);
}

export function formatEngagementPercent(rate) {
  if (rate == null || Number.isNaN(Number(rate))) return "—";
  const formatted = Number(rate).toFixed(2).replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
  return `${formatted}%`;
}

export function formatRateInr(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return "—";
  return `₹${Number(amount).toLocaleString("en-IN")}`;
}
